import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchComplainDetail = createAsyncThunk("fetchComplainDetail", async ({ id }) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`complain/detail?id=${id}`, config);

	return response.data.data;
});

const complainDetailSlice = createSlice({
	name: "complainDetail",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	reducers: {
		resetStateComplainDetail: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchComplainDetail.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchComplainDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchComplainDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetStateComplainDetail } = complainDetailSlice.actions;
export default complainDetailSlice.reducer;
